import apiCall from "../../utils/apiCall";
import {apiUrls} from "../../constants/apiUrls";
import {
    CreateTypeContainerPlatforms,
    UpdateTypeContainerPlatforms
} from "../../types/api/guide/typeContainerPlatform.types";

export const typeContainerPlatformsService = {
    getAll: () =>
        apiCall.get(apiUrls.guide.typeContainerPlatforms.getAll),

    create: (typeContainerPlatforms: CreateTypeContainerPlatforms) =>
        apiCall.post(apiUrls.guide.typeContainerPlatforms.create, typeContainerPlatforms),

    update: (id: string, typeContainerPlatforms: UpdateTypeContainerPlatforms) =>
        apiCall.put(apiUrls.guide.typeContainerPlatforms.update(id), typeContainerPlatforms),

    delete: (id: string) =>
        apiCall.delete(apiUrls.guide.typeContainerPlatforms.delete(id)),

    getById: (id: string) => {
        return apiCall.get(apiUrls.guide.typeContainerPlatforms.getById(id))
    }

}